import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { ChangeLog } from '../types/ChangeLog';
import { PaginatedResult } from '../types/PaginatedResult';
import { SingleResult } from '../types/SingleResult';
import { TasksQueue, AssignedTaskQueue } from '../types/TasksQueue';
import { httpDelete, httpGet, httpPatch, httpPost } from './api.service';

interface TaskStatusUpdate {
  status: number;
}

interface TaskUserUpdate {
  userId: string | null;
}

const getTaskQueues = async (request: PaginatedRequest): Promise<PaginatedResult<TasksQueue>> => {
  return await httpGet<PaginatedResult<TasksQueue>>(`api/task`, request);
};

const getTaskById = async (id: string): Promise<SingleResult<TasksQueue>> =>
  await httpGet<SingleResult<TasksQueue>>('api/task', { filters: [{ id: id }] });

const updateTaskStatus = async (id: string, currentStatus: TaskStatusUpdate): Promise<TasksQueue> => {
  return await httpPatch(`api/task/${id}/status`, currentStatus);
};

const getTaskQueueChangeLog = async (id: string, request: PaginatedRequest): Promise<PaginatedResult<ChangeLog>> => {
  return await httpGet(`api/task/${id}/changeLog`, request);
};

const getTaskQueueAssignableUsers = async (): Promise<AssignedTaskQueue> => {
  return await httpGet(`api/task/assignableusers?&skip=0&take=999999`);
};

const updateTaskToUser = async (id: string | null, data: TaskUserUpdate): Promise<TasksQueue> => {
  return await httpPatch(`api/task/${id}/assigneduserid`, data);
};
const addWatcherToTask = async (id: string | null, userId: string | null): Promise<AssignedTaskQueue> => {
  return await httpPost(`api/task/${id}/watcher`, { userId });
};

const removeWatcherFromTask = async (id: string | null, userId: string | null): Promise<AssignedTaskQueue> => {
  return await httpDelete(`api/task/${id}/watcher/${userId}`);
};

const updateTask = async (request: any): Promise<TasksQueue> => {
  return await httpPost(`api/task`, request);
};

// TBD
// const updateTaskOperator = async (assignTo: string): Promise<TasksQueue> => {
//   return await httpPost(`api/task/assignableusers?wildcard=${assignTo}&skip=0&take=100`);
// };

export {
  getTaskQueues,
  getTaskById,
  updateTaskStatus,
  getTaskQueueAssignableUsers,
  getTaskQueueChangeLog,
  updateTaskToUser,
  addWatcherToTask,
  removeWatcherFromTask,
  updateTask,
};
